import { render } from "./menu_top.vue?vue&type=template&id=9ca9d772&scoped=true"
import script from "./menu_top.vue?vue&type=script&lang=js"
export * from "./menu_top.vue?vue&type=script&lang=js"

import "./menu_top.vue?vue&type=style&index=0&id=9ca9d772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca9d772"]])

export default __exports__